import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import {
  fetchScheduledCampaignsSuccess,
  fetchScheduledCampaignsFailure,
} from '../slices/scheduledCampaignsSlice';
import { get } from '../../api/service/apiService';
import type { ScheduledCampaign } from '../../components/dashboard/scheduledCampaigns/types';
import ENDPOINTS from '../../api/endPoints';

function* fetchScheduledCampaignsSaga(
  action: PayloadAction<{ restaurantId: string }>
): Generator<any, void, any> {
  try {
    const { restaurantId } = action.payload;

    // Fetch scheduled campaigns
    const response = yield call(get, {
      endpoint: `${ENDPOINTS.schedule_campaign}/${restaurantId}`,
      headers: {
        'restaurantid': restaurantId
      }
    });

    const campaigns: ScheduledCampaign[] = response.data;

    // Dispatch success
    yield put(fetchScheduledCampaignsSuccess(campaigns));
  } catch (error: any) {
    yield put(
      fetchScheduledCampaignsFailure(
        error?.data?.message || error?.message || 'Failed to fetch scheduled campaigns'
      )
    );
  }
}

export function* scheduledCampaignsSaga() {
  yield takeLatest('scheduledCampaigns/fetchScheduledCampaignsRequest', fetchScheduledCampaignsSaga);
}
